"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconRedo', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M10.2929 2.70711C9.90237 2.31658 9.90237 1.68342 10.2929 1.29289C10.6834 0.902369 11.3166 0.902369 11.7071 1.29289L14.7071 4.29289C15.0976 4.68342 15.0976 5.31658 14.7071 5.70711L11.7071 8.70711C11.3166 9.09763 10.6834 9.09763 10.2929 8.70711C9.90237 8.31658 9.90237 7.68342 10.2929 7.29289L11.5858 6H6C5.03887 6 4.30435 6.32897 3.81128 6.82791C3.31642 7.32866 3 8.06636 3 9C3 9.93364 3.31642 10.6713 3.81128 11.1721C4.30435 11.671 5.03887 12 6 12H8C8.55228 12 9 12.4477 9 13C9 13.5523 8.55228 14 8 14H6C4.56113 14 3.29565 13.4956 2.38872 12.5779C1.48358 11.662 1 10.3997 1 9C1 7.60031 1.48358 6.33801 2.38872 5.42209C3.29565 4.50437 4.56113 4 6 4H11.5858L10.2929 2.70711Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M13.7929 3.20711C13.4024 2.81658 13.4024 2.18342 13.7929 1.79289C14.1834 1.40237 14.8166 1.40237 15.2071 1.79289L18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L15.2071 10.2071C14.8166 10.5976 14.1834 10.5976 13.7929 10.2071C13.4024 9.81658 13.4024 9.18342 13.7929 8.79289L15.5858 7H7C5.73887 7 4.75435 7.43313 4.08628 8.10916C3.41642 8.78699 3 9.77469 3 11C3 12.2253 3.41642 13.213 4.08628 13.8908C4.75435 14.5669 5.73887 15 7 15H10C10.5523 15 11 15.4477 11 16C11 16.5523 10.5523 17 10 17H7C5.26113 17 3.74565 16.3915 2.66372 15.2967C1.58358 14.2037 1 12.6914 1 11C1 9.30864 1.58358 7.79634 2.66372 6.70334C3.74565 5.60853 5.26113 5 7 5H15.5858L13.7929 3.20711Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M16.7929 4.20711C16.4024 3.81658 16.4024 3.18342 16.7929 2.79289C17.1834 2.40237 17.8166 2.40237 18.2071 2.79289L22.7071 7.29289C23.0976 7.68342 23.0976 8.31658 22.7071 8.70711L18.2071 13.2071C17.8166 13.5976 17.1834 13.5976 16.7929 13.2071C16.4024 12.8166 16.4024 12.1834 16.7929 11.7929L19.5858 9H8.5C5.44479 9 3 11.154 3 14C3 16.846 5.44479 19 8.5 19H11.9818C12.5341 19 12.9818 19.4477 12.9818 20C12.9818 20.5523 12.5341 21 11.9818 21H8.5C4.55521 21 1 18.154 1 14C1 9.84602 4.55521 7 8.5 7H19.5858L16.7929 4.20711Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M22.3901 6.00902C21.8328 5.39603 21.878 4.44736 22.491 3.8901C23.104 3.33284 24.0526 3.37802 24.6099 3.991L29.6099 9.491C30.1485 10.0835 30.1268 10.9945 29.5607 11.5607L24.5607 16.5607C23.9749 17.1465 23.0251 17.1465 22.4393 16.5607C21.8535 15.9749 21.8535 15.0251 22.4393 14.4394L24.8787 12H11.5C9.36668 12 7.77277 12.7372 6.70896 13.8493C5.63525 14.9719 5 16.5837 5 18.5C5 20.4163 5.63525 22.0281 6.70896 23.1507C7.77277 24.2628 9.36668 25 11.5 25H16.5C17.3284 25 18 25.6716 18 26.5C18 27.3284 17.3284 28 16.5 28H11.5C8.63332 28 6.22723 26.9872 4.54104 25.2243C2.86475 23.4719 2 21.0837 2 18.5C2 15.9163 2.86475 13.5281 4.54104 11.7757C6.22723 10.0128 8.63332 9 11.5 9H25.1092L22.3901 6.00902Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;